import React from 'react';
import { KatButton, KatRow, KatColumn } from '@amzn/katal-react';
import { useBundle } from '@amzn/react-arb-tools';
import { DemoConsumer } from './DemoView';
import { HOMEPAGE_MESSAGE_BUNDLE_NAME } from '../constants';
import { t } from 'src/helpers';

interface Props {
    nextSection: string;
    buttonId: string;
}

const ContinueButton = ({ buttonId, nextSection }: Props) => {
    const [bundle] = useBundle(HOMEPAGE_MESSAGE_BUNDLE_NAME);

    return (
        <DemoConsumer>
            {({ nextDemo }) => (
                <KatRow>
                    <KatColumn xs={12}>
                        <KatButton
                            id={buttonId}
                            className="float-right"
                            variant="primary"
                            label={t(bundle, 'continue_button_label')}
                            onClick={() => {
                                nextDemo();
                            }}
                        />
                    </KatColumn>
                </KatRow>
            )}
        </DemoConsumer>
    );
};

export default ContinueButton;
